import { useTheme } from "@mui/material";
import { SvgIconProps } from "@mui/material/SvgIcon";

export const Upload: React.FC<SvgIconProps> = (props) => {
  const { palette } = useTheme();

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      fill={palette.mode === "dark" ? "white" : palette.common.black}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.35242 7.43534C3.33523 7.65569 3.40629 7.87386 3.54996 8.04182C3.69361 8.2098 3.89811 8.31383 4.11847 8.33102C4.33883 8.34821 4.55699 8.27716 4.72496 8.13349L9.16663 4.31682V14.1668C9.16663 14.6271 9.53972 15.0002 9.99996 15.0002C10.4602 15.0002 10.8333 14.6271 10.8333 14.1668V4.31682L15.3083 8.13349C15.6581 8.43264 16.1841 8.3916 16.4833 8.04182C16.7824 7.69204 16.7414 7.16598 16.3916 6.86682L10.5583 1.86682C10.5168 1.83697 10.472 1.81182 10.425 1.79182L10.325 1.72516C10.127 1.6463 9.90629 1.6463 9.70829 1.72516L9.60829 1.79182C9.56121 1.81182 9.51649 1.83697 9.47496 1.86682L3.64163 6.86682C3.47365 7.01048 3.36962 7.21498 3.35242 7.43534ZM16.6666 15.0002C16.6666 14.5399 17.0397 14.1668 17.5 14.1668C17.9602 14.1668 18.3333 14.5399 18.3333 15.0002V16.6668C18.2577 17.6496 17.409 18.3909 16.425 18.3335H3.57496C2.59092 18.3909 1.74217 17.6496 1.66663 16.6668V15.0002C1.66663 14.5399 2.03972 14.1668 2.49996 14.1668C2.9602 14.1668 3.33329 14.5399 3.33329 15.0002V16.6085C3.40738 16.6487 3.4907 16.6688 3.57496 16.6668H16.425C16.5092 16.6688 16.5925 16.6487 16.6666 16.6085V15.0002Z"
      />
    </svg>
  );
};

export default Upload;
